<template>
  <div
    :aria-checked="active"
    aria-label="tile"
    class="bg-gray-100 rounded-lg border border-gray-400 p-3 md:p-5 cursor-pointer hover:bg-gray-200 shadow-xs flex flex-col gap-y-4"
    :class="{ 'border-blue! bg-gray-200 shadow-lg': active }"
  >
    <div class="text-blue flex justify-between">
      <div class="flex items-center gap-x-4">
        <component
          :is="icon"
          class="text-blue"
          :size="48"
        />
        <span class="text-2xl font-medium">
          {{ title }}
        </span>
      </div>
      <CheckCircle
        v-if="active"
        class="text-blue"
        :size="36"
      />
    </div>
    <div class="flex items-center justify-center flex-col">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'
import CheckCircle from 'vue-material-design-icons/CheckCircle.vue'

defineProps<{
  active: boolean
  icon: Component
  title: string
}>()

</script>
